import React, { useEffect } from 'react';
import { Dialog, DialogActions, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import { IOrder } from '../../../../interfaces/order';
import { thousands } from '../../../../utils/utils';
import Preloader from '../../../../components/ui/Preloader/Preloader';
import { useRequisites } from '../../settings/requisites/hooks/useRequisites';
import { useFormatMessage } from '../../../../hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: '10px 20px',
      width: 700,
    },
    listKey: {
      marginBottom: 10,
      fontSize: 17,
      fontWeight: 'normal',
      color: '#757575',
    },
    name: {
      fontSize: 34,
      fontWeight: 'bold',
      margin: 0,
      paddingTop: 10,
      color: '#000000',
      [theme.breakpoints.up('md')]: {
        fontSize: 34,
        lineHeight: 1.2,
      },
    },
    num: {
      marginBottom: 0,
      fontSize: 17,
      fontWeight: 'bold',
      color: '#000000',
    },
    description: {
      fontSize: 17,
      fontWeight: 400,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '23px',
      letterSpacing: 'normal',
      color: '#000000',
      whiteSpace: 'break-spaces',
      margin: 0,
    },
    cansel_btn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 25,
      height: 25,
      backgroundColor: '#d01c1f',
      borderRadius: 4,
      position: 'absolute',
      top: 10,
      right: 10,
    },
    closeIcon: {
      fontSize: 24,
      cursor: 'pointer',
    },
  })
);

export function Payment({
  open,
  handleClose,
  order,
  type,
}: {
  open: boolean;
  handleClose: () => void;
  order?: IOrder;
  type: 'buyer' | 'seller';
}) {
  const classes = useStyles();
  const fm = useFormatMessage();

  const { fetchRequisites, requisites, loading } = useRequisites();
  const siteRequisites = requisites?.requisites;

  useEffect(() => {
    fetchRequisites();
  }, []);

  if (!siteRequisites || !order) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      scroll='body'
    >
      <DialogActions style={{ overflow: 'hidden' }}>
        {!loading ? (
          <div style={{ position: 'relative' }} className={classes.container}>
            <div className={classes.cansel_btn}>
              <CloseIcon
                className={classes.closeIcon}
                onClick={handleClose}
                htmlColor='#ffffff'
              />
            </div>

            <p className={classes.name}>
              <b>
                {thousands(String(type === 'buyer' ? order.summ : order.vendor_summ))} руб.
              </b>
            </p>
            <p className={classes.listKey}>Сумма платежа</p>

            <p className={classes.num}>
              <b>
                Оплата заказа №{order.id} {type === 'buyer' ? 'на сайте chipscan.ru' : ''}
              </b>
            </p>
            <p className={classes.listKey}>Назначение платежа</p>

            {type === 'buyer' ? (
              <>
                <p className={classes.num}>
                  <b>{siteRequisites?.inn || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('COMPANY.TABLE.INN')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.kpp || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('KPP')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.ogrn || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('OGRN')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.legal_entity || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('SUBMENU.COMPANY')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.legal_address || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('LEGAL.ADDRESS')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.post_address || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('POST.ADDRESS')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.payment_account || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('PAYMENT.ACCOUNT')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.bank || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('BANK')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.bank_bic || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('BANK.BIC')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.correspondent_account || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('CORRESPONDENT.ACCOUNT')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.owner || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('OWNER')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.reason || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('REASON')}</p>
                {/* <p className={classes.listKey}>{fm('COMPANY.TABLE.INN')}</p>
                <p
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: company.payment_details }}
                /> */}
              </>
            ) : (
              <>
                <p className={classes.num}>
                  <b>{order.company?.inn || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('COMPANY.TABLE.INN')}</p>

                <p className={classes.num}>
                  <b>{order.company?.kpp || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('KPP')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.ogrn || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('OGRN')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.legal_entity || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('SUBMENU.COMPANY')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.legal_address || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('LEGAL.ADDRESS')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.post_address || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('POST.ADDRESS')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.payment_account || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('PAYMENT.ACCOUNT')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.bank || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('BANK')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.bank_bic || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('BANK.BIC')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.correspondent_account || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('CORRESPONDENT.ACCOUNT')}</p>

                <p className={classes.num}>
                  <b>{order.company?.requisites?.owner || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('OWNER')}</p>

                <p className={classes.num}>
                  <b>{siteRequisites?.reason || '-'}</b>
                </p>
                <p className={classes.listKey}>{fm('REASON')}</p>

                {/* <p className={classes.num}>
                  <b>{siteRequisites?.owner}</b>
                </p>
                <p className={classes.listKey}>{fm('OWNER')}</p> */}
                {/* <p className={classes.listKey}>{fm('COMPANY.TABLE.INN')}</p>
                <p
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: company.payment_details }}
                /> */}
              </>
            )}
          </div>
        ) : (
          <Preloader />
        )}
      </DialogActions>
    </Dialog>
  );
}
